module.exports = __webpack_public_path__ + "static/media/banner-extra-img-right.70ec2452.png";